import { el } from './ui'

// Day done, the big one (Liam picked 4 of https://claude.ai/artifact/28LD9vypuBVNiitY84eWQx, 27 Oct 2026: "I like 4 on the
// animation but bring down to four seconds"): the screen goes slate, as when Roundly opens, the lemon ring closes round
// the blob and he dances, a little confetti, then "Day done" and the day's figures. Four seconds, or until a tap
// anywhere or Close. Never waits on anything; the Undo bar stays above it; still when the phone asks for less motion
// (docs/ANIMATION-STANDARD.md: "Finishing a pile earns a bigger moment, once"). The blob is drawn as in index.html's
// loading screen, so his arms and feet can move.

const SHOWN_MS = 4000
const BLOB = `<svg class="ddm-blob" viewBox="70 180 880 660" aria-hidden="true" focusable="false"><ellipse class="ddm-shadow" cx="512" cy="814" rx="235" ry="22"/><g class="ddm-feet"><path d="M348 690L446 690C452 740 457 772 453 792C449 810 420 813 376 813C322 813 298 806 298 786C298 762 318 744 342 736Z" fill="#332c26"/><path d="M676 690L578 690C572 740 567 772 571 792C575 810 604 813 648 813C702 813 726 806 726 786C726 762 706 744 682 736Z" fill="#332c26"/></g><g class="ddm-upper"><g class="ddm-arm-l"><path d="M281 498Q182 534 161 625" fill="none" stroke="#f4dc52" stroke-width="86" stroke-linecap="round"/></g><g class="ddm-arm-r"><path d="M745 512Q852 470 864 396" fill="none" stroke="#f4dc52" stroke-width="83" stroke-linecap="round"/><circle cx="864" cy="389" r="46" fill="#f4dc52"/></g><path d="M512 212C652 212 745 300 784 445C799 500 806 545 806 600C806 668 768 736 645 736L379 736C256 736 218 668 218 600C218 545 225 500 240 445C279 300 372 212 512 212Z" fill="#f4dc52"/><circle cx="415.5" cy="420" r="28.5" fill="#332c26"/><circle cx="607.5" cy="420" r="28.5" fill="#332c26"/><path d="M455 480C482 513 543 513 569 480" fill="none" stroke="#332c26" stroke-width="27" stroke-linecap="round"/></g></svg>`
const RING = `<svg class="ddm-ring" viewBox="0 0 200 200" aria-hidden="true"><circle cx="100" cy="100" r="92" fill="none" stroke="rgba(255,255,255,.1)" stroke-width="8"/><circle class="ddm-arc" cx="100" cy="100" r="92" fill="none" stroke="#f4dc52" stroke-width="8" stroke-linecap="round"/></svg>`

// A moment that has something to ask (Send all payment texts, 0093; docs/plans/send-all-texts/PLAN.md, B1): it stops
// its four seconds, a tap outside no longer puts it away, Close does, and the card sits above Close.
const asks = new WeakMap<HTMLElement, { ask: (card: HTMLElement) => void; leave: () => void }>()
export function askOnDayDone(take: HTMLElement, card: HTMLElement): boolean {
  const a = asks.get(take)
  if (!a || !take.isConnected || take.classList.contains('ddm-leaving')) return false
  a.ask(card)
  return true
}
export function leaveDayDone(take: HTMLElement): void { asks.get(take)?.leave() }

export function showDayDoneMoment(words: string): HTMLElement {
  document.querySelector('.day-done-take')?.remove()
  const stage = el('div', { class: 'ddm-stage' })
  // Constant drawings of the brand's own shapes, no customer text: set as markup.
  stage.innerHTML = RING + BLOB
  const confetti = el('div', { class: 'ddm-confetti', 'aria-hidden': 'true' })
  for (let i = 0; i < 22; i++) {
    const a = (i / 22) * Math.PI * 2 + (i % 3) * 0.3, d = 70 + (i % 5) * 16
    const bit = el('i', {})
    bit.style.setProperty('--x', `${Math.round(Math.cos(a) * d)}px`); bit.style.setProperty('--y', `${Math.round(Math.sin(a) * d - 40)}px`); bit.style.setProperty('--r', `${(i * 47) % 360}deg`)
    confetti.append(bit)
  }
  const close = el('button', { type: 'button', class: 'ddm-close' }, 'Close')
  const take = el('div', { class: 'day-done-take', role: 'status', 'aria-live': 'polite' }, stage, confetti,
    el('h2', {}, 'Day done'), el('p', {}, words), close)
  let gone = false
  const leave = (): void => {
    if (gone) return
    gone = true
    window.clearTimeout(timer)
    document.removeEventListener('keydown', onKey)
    take.classList.add('ddm-leaving')
    window.setTimeout(() => take.remove(), 300)
  }
  const onKey = (e: KeyboardEvent): void => { if (e.key === 'Escape') leave() }
  // A tap anywhere puts it away: it never stands between the owner and the next thing.
  take.addEventListener('click', leave)
  document.addEventListener('keydown', onKey)
  const timer = window.setTimeout(leave, SHOWN_MS)
  asks.set(take, {
    leave,
    ask: (card) => {
      window.clearTimeout(timer)
      take.removeEventListener('click', leave)
      close.addEventListener('click', leave)
      take.classList.add('ddm-asking')
      close.before(card)
    },
  })
  document.body.append(take)
  return take
}
